import React from "react";
import { PropTypes } from "prop-types";
import { themes } from "../../theme";

const FAQIcon = ({ children, color, ...props }) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
  >
    {children}
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g>
        <rect x="0" y="0" width="24" height="24" />
        <path
          fill={color}
          {...color !== "currentColor" && { fillOpacity: ".65" }}
          fillRule="nonzero"
          d="M9.5,22 C9.77614237,22 10,22.2238576 10,22.5 C10,22.7761424 9.77614237,23 9.5,23 L2.5,23 C1.11928813,23 2.35922393e-15,21.8807119 2.22044605e-15,20.5 L0,2.5 C-1.38777878e-16,1.11928813 1.11928813,2.77555756e-16 2.5,0 L14.5,0 C15.8807119,9.71445147e-16 17,1.11928813 17,2.5 L17,6.5 C17,6.77614237 16.7761424,7 16.5,7 C16.2238576,7 16,6.77614237 16,6.5 L16,2.5 C16,1.67157288 15.3284271,1 14.5,1 L2.5,1 C1.67157288,1 1,1.67157288 1,2.5 L1,20.5 C1,21.3284271 1.67157288,22 2.5,22 L9.5,22 Z M3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 L13.5,5 C13.7761424,5 14,5.22385763 14,5.5 C14,5.77614237 13.7761424,6 13.5,6 L3.5,6 Z M3.5,11 C3.22385763,11 3,10.7761424 3,10.5 C3,10.2238576 3.22385763,10 3.5,10 L8.5,10 C8.77614237,10 9,10.2238576 9,10.5 C9,10.7761424 8.77614237,11 8.5,11 L3.5,11 Z M3.5,16 C3.22385763,16 3,15.7761424 3,15.5 C3,15.2238576 3.22385763,15 3.5,15 L7.5,15 C7.77614237,15 8,15.2238576 8,15.5 C8,15.7761424 7.77614237,16 7.5,16 L3.5,16 Z M16.5,24 C12.3578644,24 9,20.6421356 9,16.5 C9,12.3578644 12.3578644,9 16.5,9 C20.6421356,9 24,12.3578644 24,16.5 C24,20.6421356 20.6421356,24 16.5,24 Z M16.5,23 C20.0898509,23 23,20.0898509 23,16.5 C23,12.9101491 20.0898509,10 16.5,10 C12.9101491,10 10,12.9101491 10,16.5 C10,20.0898509 12.9101491,23 16.5,23 Z M17,18.5 C17,18.7761424 16.7761424,19 16.5,19 C16.2238576,19 16,18.7761424 16,18.5 L16,17 C16,16.8328234 16.0835506,16.6767077 16.2226499,16.5839749 C17.6894365,15.6061171 18,15.2334409 18,14.5 C18,13.5580333 17.5349723,13 16.5,13 C15.4650277,13 15,13.5580333 15,14.5 C15,14.7761424 14.7761424,15 14.5,15 C14.2238576,15 14,14.7761424 14,14.5 C14,13.0419667 14.8683056,12 16.5,12 C18.1316944,12 19,13.0419667 19,14.5 C19,15.6146202 18.5417641,16.2141297 17,17.2659442 L17,18.5 Z M16.5,20 C16.775,20 17,20.224 17,20.5 C17,20.775 16.775,21 16.5,21 C16.223,21 16,20.775 16,20.5 C16,20.224 16.223,20 16.5,20 Z"
        />
      </g>
    </g>
  </svg>
);

FAQIcon.displayName = "FAQIcon";

FAQIcon.propTypes = {
  children: PropTypes.node,
  color: PropTypes.string
};

FAQIcon.defaultProps = {
  children: null,
  color: themes.global.gray01
};

export default FAQIcon;
